import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg'

import styles from './SprintCard.module.scss'
interface SprintCardProps {
  size?: string
  color?: string
  svgIcon?: any
  topBarClass?: string
  bullets?: any
  link: any
}

export const SprintCard: React.FC<SprintCardProps> = ({ size, svgIcon, topBarClass, color, bullets, link }) => {
  return (
    <div
      className={`${link && styles.sprintCard} border-[2px] border-black border-solid rounded-2xl p-6 flex flex-col w-full h-full`}
    >
      <div className={`${topBarClass} h-2 mb-2 rounded-8`} style={{ backgroundColor: color }} />
      <div className="w-full flex justify-between rounded-8 h-14 p-2" style={{ backgroundColor: color }}>
        <div className="flex flex-col font-bold">
          <span className="text-12">SPRINT SIZE</span>
          <span>{size}</span>
        </div>
        <div className="h-full">{svgIcon}</div>
      </div>
      {bullets.map((el: { title: string; description: string }, index: number) => {
        const border = index > 0 ? 'border-t' : ''
        const height = index > 1 ? 'h-[64px]' : 'h-[104px]'
        return (
          <div className={`py-3 border-solid  ${border} ${height}`} style={{ borderColor: '#B6B6B6' }}>
            <p className="font-bold" style={{ fontSize: 11 }}>
              {el.title}
            </p>
            <p className="font-normal text-12 ">{el.description}</p>
          </div>
        )
      })}
      {link && (
        <a href={link} target="blank_" className="flex text-12 justify-center align-middle font-semibold pt-1">
          See example <ArrowRight className="pl-1" />
        </a>
      )}
    </div>
  )
}
